// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__1z_g_","recentlyUpdated":"styles_recentlyUpdated__2XvBN"};